'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var LocalizationMixin = require('../localization/CommonLocalizationMixin');
var ADAHelpers = require('../lib/ADAHelpers');

var BackButton = createReactClass({
    displayName: 'BackButton',
    mixins: [LocalizationMixin],

    propTypes: {
        buttonText: PropTypes.string,
        handleClick: PropTypes.func.isRequired,
        darkTheme: PropTypes.bool
    },

    render: function render() {
        return React.createElement(
            'div',
            { className: "back-button-background" + (this.props.darkTheme ? " dark-theme" : "") },
            React.createElement(
                'div',
                { className: 'container' },
                React.createElement(
                    'div',
                    { className: 'back-wrapper',
                        onClick: this.props.handleClick,
                        onKeyDown: ADAHelpers.keyupHandler,
                        role: 'button', tabIndex: '0' },
                    React.createElement('img', { className: "rotate-image" + (this.props.darkTheme ? " dark-theme" : ""), src: '/images/icons/ic_nav_arrow.png' }),
                    React.createElement(
                        'div',
                        { className: 'back' },
                        this.props.buttonText || this.getLocalizedText("rewards_back")
                    )
                )
            )
        );
    }
});

module.exports = BackButton;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/backButton.js
// module id = 735
// module chunks = 0